<template>
  <div class="accountsReceivable" ref="dataCenter1">
    <div class="mainContentWrap">
      <div class="top2">
        <el-row>
          <el-col :span="6">
            <div class="echartWrap" v-if="auditAmountDeptList.length>0">
              <div class="title">{{auditAmountDeptList[0]['deptName']}}</div>
              <div class="sum">审计额或已完成产值：{{formatCurrency(auditAmountDeptList[0]['auditAmount'])}}</div>
              <div class="echart1" id="echart211"></div>
            </div>
            <div class="echartWrap" v-else>
              <div class="title"></div>
              <div class="noechart">暂无数据</div>
            </div>
            <div class="echartWrap" v-if="auditAmountDeptList.length>1">
              <div class="title">{{auditAmountDeptList[1]['deptName']}}</div>
              <div class="sum">审计额或已完成产值：{{formatCurrency(auditAmountDeptList[1]['auditAmount'])}}</div>
              <div class="echart1" id="echart212"></div>
            </div>
            <div class="echartWrap" v-else>
              <div class="title"></div>
              <div class="noechart">暂无数据</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="echartWrapCenter">
              <div class="top2_top">
                <div class="top2_title">
                  应收账款
                  <div class="unitClass">单位：元</div>
                </div>

                <el-row>
                  <el-col :span="10">
                    <div class="top_sum">
                      公司总审计额或已完成产值
                      <br />
                      {{formatCurrency(sumData.auditAmountTotal)}}
                    </div>
                    <div class="top_sum top_sum1">
                      应收账款
                      <br />
                      {{formatCurrency(sumData.debtTotalMoneyTotal)}}
                    </div>
                  </el-col>
                  <el-col :span="14">
                    <div class="echart1" id="echart21CenterTop"></div>
                  </el-col>
                </el-row>
              </div>
              <div class="top2_bottom">
                <div class="echart1" id="echart21CenterBottom"></div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="echartWrap" v-if="auditAmountDeptList.length>5">
              <div class="title">{{auditAmountDeptList[5]['deptName']}}</div>
              <div class="sum">审计额或已完成产值：{{formatCurrency(auditAmountDeptList[5]['auditAmount'])}}</div>
              <div class="echart1" id="echart216"></div>
            </div>
            <div class="echartWrap" v-else>
              <div class="title"></div>
              <div class="noechart">暂无数据</div>
            </div>
            <div class="echartWrap" v-if="auditAmountDeptList.length>6">
              <div class="title">{{auditAmountDeptList[6]['deptName']}}</div>
              <div class="sum">审计额或已完成产值：{{formatCurrency(auditAmountDeptList[6]['auditAmount'])}}</div>
              <div class="echart1" id="echart217"></div>
            </div>
            <div class="echartWrap" v-else>
              <div class="title"></div>
              <div class="noechart">暂无数据</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="bottom1">
        <el-col :span="6">
          <div class="echartWrap" v-if="auditAmountDeptList.length>2">
            <div class="title">{{auditAmountDeptList[2]['deptName']}}</div>
            <div class="sum">审计额或已完成产值：{{formatCurrency(auditAmountDeptList[2]['auditAmount'])}}</div>
            <div class="echart1" id="echart213"></div>
          </div>
          <div class="echartWrap" v-else>
            <div class="title"></div>
            <div class="noechart">暂无数据</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="echartWrap" v-if="auditAmountDeptList.length>3">
            <div class="title">{{auditAmountDeptList[3]['deptName']}}</div>
            <div class="sum">审计额或已完成产值：{{formatCurrency(auditAmountDeptList[3]['auditAmount'])}}</div>
            <div class="echart1" id="echart214"></div>
          </div>
          <div class="echartWrap" v-else>
            <div class="title"></div>
            <div class="noechart">暂无数据</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="echartWrap" v-if="auditAmountDeptList.length>4">
            <div class="title">{{auditAmountDeptList[4]['deptName']}}</div>
            <div class="sum">审计额或已完成产值：{{formatCurrency(auditAmountDeptList[4]['auditAmount'])}}</div>
            <div class="echart1" id="echart215"></div>
          </div>
          <div class="echartWrap" v-else>
            <div class="title"></div>
            <div class="noechart">暂无数据</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="echartWrap" v-if="auditAmountDeptList.length>7">
            <div class="title">{{auditAmountDeptList[7]['deptName']}}</div>
            <div class="sum">审计额或已完成产值：{{formatCurrency(auditAmountDeptList[7]['auditAmount'])}}</div>
            <div class="echart1" id="echart218"></div>
          </div>
          <div class="echartWrap" v-else>
            <div class="title"></div>
            <div class="noechart">暂无数据</div>
          </div>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
import { getReceiveAnalysisAuditAmount } from "../../services/dataCenterAService";

var echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pie");
require("echarts/lib/chart/line");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  name: "accountsReceivable",
  data() {
    return {
      //中间金额部分 数据
      sumData: {},
      echartsSumData: [], //中间柱状图数据
      echartsSumDataName: [], //中间柱状图echart x轴名称
      //周围图表数据
      auditAmountDeptList: [],
      echart21CenterBottom: null,
      allEchart21: {}
    };
  },
  methods: {
    setWrapHeight21() {
      let _this = this;
      //外面div大小
      let ch = document.documentElement.clientHeight;
      let cw = document.documentElement.clientWidth - 40;
      // 里面的div大小
      let chw = document.documentElement.clientHeight - 100;
      let cww = document.documentElement.clientWidth - 60;
      if (document.getElementById("aside")) {
        ch = ch - 50 - 30;
        cw = cw - 280;
        chw = chw - 50 - 30;
        cww = cww - 280;
      }
      if (chw < 700) {
        chw = 700;
      }
      if (cww < 1560) {
        cww = 1560;
      }
      // document.getElementsByClassName("accountsReceivable")[0].style.width =
      //   cww + "px";
      document.getElementsByClassName("accountsReceivable")[0].style.height =
        chw + "px";
      this.$nextTick(() => {
        if (_this.echart21CenterBottom) {
          _this.echart21CenterBottom.resize();
        }
        if (_this.allEchart21) {
          for (let i in _this.allEchart21) {
            if (_this.allEchart21[i]) {
              _this.allEchart21[i].resize();
            }
          }
        }
      });
    },
    search(searchData) {
      let _this = this;
      //查询看板数据
      let params = {};
      if (searchData.monthDate) {
        params.monthDate = searchData.monthDate;
      }
      if (searchData.projectProcess) {
        params.projectProcess = searchData.projectProcess;
      }
      getReceiveAnalysisAuditAmount(params)
        .then(res => {
          if (res.code === 10000000) {
            this.allEchart21 = {};
            _this.sumData = res.data;
            _this.auditAmountDeptList = res.data.auditAmountDeptList;
            _this.echartsSumData = [[], [], []]; //中间柱状图数据
            _this.echartsSumDataName = []; //中间柱状图echart名称
            _this.auditAmountDeptList.forEach((item, index) => {
              _this.echartsSumData[0].push(item.auditAmount);
              _this.echartsSumData[1].push(item.collectedMoney);
              _this.echartsSumData[2].push(item.debtTotalMoney);
              _this.echartsSumDataName.push(item.deptName);
            });
            this.$nextTick(() => {
              this.setData(); //周围饼状图
              //中间部分饼状图
              let centerParams = {
                collectedMoney: _this.sumData.collectedMoneyTotal,
                debtTotalMoney: _this.sumData.debtTotalMoneyTotal
              };
              this.draw(centerParams, "CenterTop"); //中间饼状图
              this.drawBar(); //中间柱状图
            });
          } else if (res.code > 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$message.error("系统异常");
          }
        })
        .catch(error => {
          this.$message.error("系统异常");
        });
    },

    setData() {
      let _this = this;
      this.auditAmountDeptList.forEach((item, index) => {
        setTimeout(() => {
          _this.draw(item, index + 1);
        }, 20);
      });
    },
    //    绘制echarts饼状图图
    draw(item, index) {
      let _this = this;
      let idName = "echart21" + index;
      this.$set(
        this.allEchart21,
        idName,
        echarts.init(document.getElementById(idName))
      );
      // let myChart = echarts.init(document.getElementById(idName));
      let option = {
        title: {
          show: false
        },
        tooltip: {
          trigger: "item",
          showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
          hideDelay: 20, // 隐藏延迟，单位ms
          textStyle: {
            fontSize: "16px",
            color: "#fff" // 设置文本颜色 默认#FFF
          },
          formatter: "{b} : {d}%"
        },
        legend: {
          orient: "horizontal",
          icon: "circle",
          bottom: 0,
          itemHeight: 5,
          itemWidth: 5,
          left: "center",
          data: ["已收款", "应收账款"]
        },
        color: ["#f79646", "#4bacc6"],
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            center: ["50%", "45%"],
            data: [
              // {value: parseInt(item.collectedPct), name: "已收款"},
              // {value: parseInt(item.debtPct), name: "应收账款"}
              { value: item.collectedMoney, name: "已收款" },
              { value: item.debtTotalMoney, name: "应收账款" }
            ],

            // 设置值域的那指向线
            labelLine: {
              normal: {
                show: false // show设置线是否显示，默认为true，可选值：true ¦ false
              }
            },
            // 设置值域的标签
            label: {
              normal: {
                padding: [0, -26],
                textStyle: {
                  fontSize: 12,
                  color: "rgba(0,0,0,0.8)"
                },
                // formatter: "{b}\n{d}%"
                formatter: function(params) {
                  let txt = "";
                  txt =
                    params.name +
                    "\n" +
                    params.percent +
                    "%" +
                    "\n" +
                    _this.formatCurrency(params.value);
                  return txt;
                }
              }
            }
          }
        ]
      };
      // myChart.resize();
      this.allEchart21[idName].setOption(option);
    },
    //绘制柱状图
    drawBar() {
      this.echart21CenterBottom = echarts.init(
        document.getElementById("echart21CenterBottom")
      );
      let option = {
        legend: {
          orient: "horizontal",
          bottom: 6,
          itemHeight: 8,
          itemWidth: 8,
          left: "center"
        },
        grid: {
          left: "5%",
          right: "4%",
          bottom: "14%",
          top: "10%",
          containLabel: true
        },
        tooltip: {},
        color: ["#8064a2", "#f79646", "#4bacc6"],
        xAxis: {
          data: this.echartsSumDataName,
          axisLabel: {
            interval: 0,
            rotate: 40
          },
          axisLine: {
            // 坐标轴 轴线
            show: false // 是否显示
          },
          axisTick: {
            // 坐标轴的刻度
            show: false // 是否显示
          }
        },
        yAxis: {
          show: true, // 是否显示
          type: "value", // 轴类型，默认为 ‘category’
          axisLine: {
            // 坐标轴 轴线
            show: false // 是否显示
          },
          axisTick: {
            // 坐标轴的刻度
            show: false // 是否显示
          },
          min: 0
        },
        series: [
          {
            name: "审计额或已完成产值",
            type: "bar",
            barWidth: 12, // 柱形的宽度
            data: this.echartsSumData[0]
          },
          {
            name: "已收款",
            type: "bar",
            barWidth: 12, // 柱形的宽度
            data: this.echartsSumData[1]
          },
          {
            name: "应收账款",
            type: "bar",
            barWidth: 12, // 柱形的宽度
            data: this.echartsSumData[2]
          }
        ]
      };
      this.echart21CenterBottom.resize();
      this.echart21CenterBottom.setOption(option, true);
    },
    //数字用逗号隔开
    formatCurrency(num) {
      num = Number(num);
      num = num.toFixed(2);
      if (num === 0) {
        return 0;
      } else if (num) {
        num = num.toString().replace(/\$|\,/g, "");
        if (num === "" || isNaN(num)) {
          return 0;
        }
        var sign = "";
        if (num.indexOf("-") !== -1) {
          sign = "-";
          num = num.substr(1);
        }
        var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
        cents = cents.length > 1 ? cents : "";
        num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
        if (cents === "") {
          if (num.length > 1 && num.substr(0, 1) === "0") {
            return 0;
          }
        } else {
          if (num.length > 1 && num.substr(0, 1) === "0") {
            return 0;
          }
        }
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
          num =
            num.substring(0, num.length - (4 * i + 3)) +
            "," +
            num.substring(num.length - (4 * i + 3));
        }
        return sign + num + cents;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.accountsReceivable {
  /*height: calc(100% - 20px);*/
  /*height: 720px;*/
  /*width: 1560px;*/
  /*text-align: left;*/
  /*!*overflow: hidden;*!*/
  /*background: #ffffff;*/
  /*padding: 10px;*/
  /*width: 98%;*/
  text-align: left;
  overflow: hidden;
  background: #ffffff;
  padding: 0 10px;
  /*height: 1660px;*/
  margin: 0 auto;

  .mainContentWrap {
    /*width: 100%;*/
    /*overflow: hidden;*/
    /*height: calc(100% - 100px);*/
    height: 100%;

    .el-row {
      height: 100%;
    }

    .el-col {
      height: 100%;
    }

    .top2 {
      height: 66%;

      .echartWrapCenter {
        width: calc(100% - 10px);
        height: calc(100% - 10px);
        border: 1px solid #c8c8c8;
        margin: 5px;

        .el-row {
          height: calc(100% - 50px);

          .echart1 {
            height: 100%;
          }
        }

        .top2_top {
          height: 50%;

          .top2_title {
            text-align: center;
            font-size: 20px;
            line-height: 50px;
            font-weight: 600;

            .unitClass {
              float: right;
              font-size: 14px;
              margin-right: 40px;
            }
          }

          .top_sum {
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            line-height: 30px;
            background: #bdd0e9;
            /*padding: 5px 0;*/
            width: 85%;
            margin: 5px auto 15px;
          }

          .top_sum1 {
            background: #f4b183;
            margin: 0 auto;
          }
        }

        .top2_bottom {
          height: 50%;

          .echart1 {
            height: 100%;
          }
        }
      }

      .echartWrap {
        height: calc(50% - 10px);
      }
    }

    .bottom1 {
      height: 33%;

      .echartWrap {
        height: calc(100% - 10px);
      }
    }

    .echartWrap {
      width: calc(100% - 10px);
      height: calc(100% - 10px);
      border: 1px solid #c8c8c8;
      margin: 5px;

      .title {
        text-align: center;
        font-size: 16px;
        margin: 5px 0;
        font-weight: 600;
      }

      .sum {
        font-size: 14px;
        margin: 0 0 5px 0px;
        font-weight: 600;
      }

      .echart1 {
        height: calc(100% - 50px);
      }
      .noechart {
        height: calc(100% - 50px);
        text-align: center;
        font-size: 20px;
        line-height: 50px;
        font-weight: 600;
        padding-top: 80px;
      }
    }
  }
}
</style>

